import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function ParkingIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 3H7V21H11V15H14C17.31 15 20 12.31 20 9C20 5.69 17.31 3 14 3ZM14.2 11H11V7H14.2C15.3 7 16.2 7.9 16.2 9C16.2 10.1 15.3 11 14.2 11Z",
    fill: "currentColor"
  }));
}